export default "__VITE_ASSET__BwQ3C2tm__"